import { render, staticRenderFns } from "./MelkwegBanner.vue?vue&type=template&id=1b8f1024&scoped=true&"
import script from "./MelkwegBanner.vue?vue&type=script&lang=js&"
export * from "./MelkwegBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f1024",
  null
  
)

export default component.exports